import React, { useContext } from 'react'
import { CollapsibleContext } from 'client/fragments/listerFragment/components/Filters/Collapsible/Collapsible'

export const CollapsibleBody = ({ children }) => {
  const { isCollapsed } = useContext(CollapsibleContext)
  if (isCollapsed) return null
  return <>{children}</>
}
